import type { CASelectedFilters } from '@ds/interfaces'
import type { Certification, ComplianceBundle } from '@vuejs/services/courses/interfaces'

import type { ApiClient } from '../api'
import {
	apiRouteBuilder,
	getComplianceBundles as complianceBundlesRoute,
	getCourseCatalog,
	getRecommendedSpecializedBundles,
} from '../apiRoutes'
import type { CatalogList } from './interfaces'

export async function getComplianceBundles(api: ApiClient, {
	agencyId,
	filterValues,
	page,
	perPage,
	search,
}:
CatalogRequest) {
	const route = apiRouteBuilder(complianceBundlesRoute, { agencyId })
	const { data } = await api.get<ApiComplianceBundlesResponse>(route, {
		agencyId,
		filterValues,
		page,
		perPage,
		search,
	})

	return data
}

export async function getFullCatalog(api: ApiClient, {
	agencyId,
	filterValues,
	page,
	perPage,
	search,
}:
CatalogRequest) {
	const route = apiRouteBuilder(getCourseCatalog, { agencyId })
	const { data } = await api.get<ApiCatalogListResponse>(route, {
		agencyId,
		filterValues,
		page,
		perPage,
		search,
	})

	return data
}

export async function getSpecializedBundles(api: ApiClient, {
	agencyId,
	filterValues,
	page,
	perPage,
	search,
}:
CatalogRequest) {
	const route = apiRouteBuilder(getRecommendedSpecializedBundles, { agencyId })
	const { data } = await api.get<ApiRecommendedSpecializedBundlesResponse>(route, {
		agencyId,
		filterValues,
		page,
		perPage,
		search,
	})

	return data
}

export type ApiCatalogListResponse = CatalogResponse
export type ApiComplianceBundlesResponse = ComplianceBundlesResponse
export type ApiRecommendedSpecializedBundlesResponse = RecommendationsCatalogResponse

export interface CatalogRequest {
	agencyId: number
	filterValues: CASelectedFilters
	page: number
	perPage: number
	search: string
}

export interface CatalogResponse {
	data: CatalogList[]
	pagination: {
		current_page: number
		per_page: number
		total: number
	}
}

export interface ComplianceBundlesResponse {
	data: ComplianceBundle[]
	pagination: {
		current_page: number
		per_page: number
		total: number
	}
}

export interface RecommendationsCatalogResponse {
	data: Certification[]
	pagination: {
		current_page: number
		per_page: number
		total: number
	}
}
